<header>
    <div class="m-header">
      <button
        type="button"
        class="mobile-menu"
        id="mobile-collapse1"
        (click)="onNavCollapsedMob.emit()"
        [attr.aria-label]="'Open menu'">
        <span></span>
      </button>
    </div>
    <div class="collapse navbar-collapse">
      <app-nav-left class="nav-bar__welcome"></app-nav-left>
      <app-nav-right class="flex-grow"></app-nav-right>
    </div>
  </header>